import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class EdListHomeworkLoading extends Vue {

  public rows: number = 0;

  setRows() {
    let height = Number(document.getElementById('EdListHomeworkLoading')?.offsetHeight);
    if(!height || height==Number.NaN){
      height = 0;
    }
    this.rows = height == 0 ? 0 : Math.floor((height - 10)/35);
  }

  mounted() {
    this.setRows();
  }

}